module.exports = __webpack_public_path__ + "img/A_footer.148a0caf.png";